var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useGetFavoritesQuery, useGetImportableModulesQuery, } from "@/store/api";
import { Dropdown, MenuButton, Menu } from "@mui/joy";
import { useEffect, useMemo, useState } from "react";
import ModuleList from "../list/moduleList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SlotDirection } from "@/utils/types/layout";
import { slotDirection } from "@/utils/funcs";
import { faStars } from "@fortawesome/pro-solid-svg-icons";
import FavoriteRecord from "./favorite";
import { useParams } from "react-router-dom";
export default function WidgetFavorite(_a) {
    var _b, _c, _d;
    var widget = _a.widget;
    var current = (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.current;
    var module = useParams().module;
    var target_module = current
        ? module
            ? module
            : (_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.target_module
        : (_d = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _d === void 0 ? void 0 : _d.target_module;
    var favoriteResponse = useGetFavoritesQuery({
        params: {
            module: target_module,
        },
    }).data;
    var _e = useState([]), records = _e[0], setRecords = _e[1];
    var _f = useState(""), label = _f[0], setLabel = _f[1];
    var _g = useState(""), noData = _g[0], setLabelNoData = _g[1];
    useEffect(function () {
        var resp = (favoriteResponse === null || favoriteResponse === void 0 ? void 0 : favoriteResponse.data) || {};
        var rec = (resp === null || resp === void 0 ? void 0 : resp.records) || {};
        setLabel(resp === null || resp === void 0 ? void 0 : resp.LBL_FAVORITES);
        setLabelNoData(resp === null || resp === void 0 ? void 0 : resp.LBL_NO_DATA);
        setRecords(Object.values(rec));
    }, [favoriteResponse]);
    var direction = widget.slot
        ? slotDirection(widget.slot)
        : SlotDirection.VERTICAL;
    return (_jsx(_Fragment, { children: direction === "HORIZONTAL" ? (_jsxs(Dropdown, { children: [_jsx(MenuButton, __assign({ sx: {
                        border: "none",
                        "&:hover": {
                            background: "none",
                        },
                    } }, { children: _jsx(FontAwesomeIcon, { icon: faStars, size: "xl", title: label }) })), records && (_jsxs(Menu, __assign({ sx: {
                        background: "var(--colors-bg-default)",
                        width: "15%",
                        maxHeight: "90%",
                        overflow: "auto",
                    } }, { children: [records &&
                            records.length > 0 &&
                            records.map(function (item) { return (_jsx(FavoriteRecord, { record: item })); }), records.length === 0 && (_jsxs("span", __assign({ className: "pl-2 bg-[var(--colors-widget)]" }, { children: [" ", noData] })))] })))] })) : (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: " h-full text-[var(--colors-label)] overflow-auto    mt-[var(--margin-mt-widget)] mr-[var(--margin-mr-widget)] mb-[var(--margin-mb-widget)] ml-[var(--margin-ml-widget)]" }, { children: [_jsx("div", __assign({ className: "" }, { children: _jsx("h2", __assign({ className: "uppercase font-bold justify-center items-center flex p-2" }, { children: /*`Favoris : ${widget?.payload.target_module} `*/ label })) })), records && (_jsxs("ul", __assign({ className: "bg-[var(--colors-bg-default)] py-[1px]" }, { children: [records &&
                                records.map(function (item) { return (_jsx(_Fragment, { children: _jsx(FavoriteRecord, { record: item, isVertical: true }) })); }), records.length === 0 && (_jsx("li", __assign({ className: "pl-2 bg-[var(--colors-widget)]" }, { children: noData })))] })))] })) })) }));
}
function WidgetSettings(_a) {
    var widget = _a.widget, onChange = _a.onChange;
    var _b = useGetImportableModulesQuery(null), menuResponse = _b.data, isLoading = _b.isLoading;
    // Memo : all modules used for translation
    var allModules = useMemo(function () {
        var _a;
        return (menuResponse && ((_a = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _a === void 0 ? void 0 : _a.modules)) || {};
    }, [menuResponse]);
    return (_jsxs("div", __assign({ className: "w-[340px] mt-4" }, { children: [_jsxs("label", { children: [_jsx("input", { value: (widget === null || widget === void 0 ? void 0 : widget.payload.current) || true, type: "checkbox", checked: widget === null || widget === void 0 ? void 0 : widget.payload.current, onChange: function (e) {
                            onChange &&
                                onChange(widget, __assign(__assign({}, widget.payload), { current: e.currentTarget.checked }));
                        }, className: "mr-2" }), "module courant"] }), !(widget === null || widget === void 0 ? void 0 : widget.payload.current) && (_jsx(ModuleList, { module: (widget === null || widget === void 0 ? void 0 : widget.payload.target_module) || "", options: allModules, onChange: function (event, v) {
                    onChange &&
                        onChange(widget, __assign(__assign({}, widget.payload), { target_module: v }));
                } }))] })));
}
widgetsDictionary.register("widget/favorite", {
    name: "Widget mes favoris",
    description: "Affiche la liste de favoris.",
    display: WidgetFavorite,
    settings: WidgetSettings,
    selectable: true,
});
